const formatLabelString = (labelStr: string) => {
  return labelStr ? labelStr.toLowerCase().replace(/[^a-zA-Z]+/g, '') : ''
}

/**
 * Get translated display labels for RAC sections
 * @param displayLabels object containing all display label translation/manual display field value
 * @param label current label which is to be updated if value available
 * @returns the translated label if provided in displayLabels, otherwise label
 */
export const updateDisplayLabel = (displayLabels: Object, label: string) => {
  let translatedLabel = label
  let formattedLabel = formatLabelString(label)
  // Special case: key is differant than formatted label
  if (formattedLabel === 'additionaldisclosuresforunsolicitedcreditratings')
    formattedLabel = 'unsolicitedissuers'
  if (Object.prototype.hasOwnProperty.call(displayLabels, formattedLabel))
    translatedLabel = displayLabels[formattedLabel]

  return translatedLabel
}

export default updateDisplayLabel
